(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Progetto', Progetto);

    Progetto.$inject = ['$resource', 'DateUtils'];

    function Progetto ($resource, DateUtils) {
        var resourceUrl =  'api/progettos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
